// src/components/BranchOrders.js
import React from "react";
import { useParams } from "react-router-dom";
import { indexStore } from "src/store/indexStore";
import { OrderStatus } from "src/enums/orderStatus";
import OrderTabs from "./OrdersTabs/OrderTabs";
import { useTranslation } from "react-i18next";
import { ShoppingCart } from "lucide-react";

const Orders = () => {
  const { branchId } = useParams();
  const { fetchOrdersByStatusFunction } = indexStore();
  const { t } = useTranslation();
  
  const tabConfig = [
    { key: OrderStatus.pending, title: t("orderStatus.pending") },
    { key: OrderStatus.processing, title: t("orderStatus.processing") },
    { key: OrderStatus.delivarying, title: t("orderStatus.delivarying") },
    { key: OrderStatus.completed, title: t("orderStatus.completed") },
    { key: OrderStatus.canseled, title: t("orderStatus.canseled") },
  ];
  
  return (
    <div className="flex flex-col gap-6">
      {/* Header Section */}
      <div className="flex items-center gap-3">
        <div className="p-3 rounded-lg bg-gradient-to-br from-primary/10 to-transparent border">
          <ShoppingCart className="w-6 h-6 text-primary" />
        </div>
        <div>
          <h2 className="text-2xl font-bold text-foreground">{t("dashbord.orders")}</h2>
          <p className="text-sm text-muted-foreground">
            {t("gloabl.manage_orders") || "View and manage all orders"}
          </p>
        </div>
      </div>

      <OrderTabs
        statuses={tabConfig}
        branchId={branchId}
        fetchOrdersByStatusFunction={fetchOrdersByStatusFunction}
      />
    </div>
  );
};

export default Orders;
